export default "__VITE_ASSET__BMtxXgA2__"